import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { ProjectEntity } from '../models/Project';

const actionConfig = { resourcePath: '/projects' };

type ProjectsStoreState = RestStoreState<ProjectEntity>;

export const projectActions = {
  ...createRestActions<ProjectEntity>(actionConfig),
  clearProjects: () => ({ setState }: StoreActionApi<ProjectsStoreState>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const ProjectsStore = createRestStore<ProjectEntity>({
  actions: projectActions,
  actionConfig,
  containerDisplayName: 'projects-container',
  onInitAction: null,
});

export const useProjectsData = createDataHook(ProjectsStore);
export const useProjectsIsLoading = createLoadingHook(ProjectsStore);
export const useProjectsActions = createActionsHook(ProjectsStore);
export const didProjectsMutationFail = createMutationFailedCheck(actionConfig.resourcePath);

